import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-auto">
      <div className="container mx-auto px-4 text-center">
        <p>&copy; {new Date().getFullYear()} MM FIREWORKS. All rights reserved.</p>
        <p className="mt-2">Sivakasi, Tamil Nadu</p>
      </div>
    </footer>
  );
}

export default Footer;